import * as React from "react";
import {none, option, Option} from "ts-option";
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router";
import ButtonPrimary from "../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import "./revolutAuthorization.scss";
import {api} from "../../api/api";
import {notifyBugsnagAndShowToast} from "../../utils/Utils";

const logo = require('../../../resources/hiber/img/dg-logo-big-green.png');

interface State {
	loading: boolean,
	error: Option<string>
}

type Props = RouteComponentProps<{}>;

class XeroAuthorization extends React.PureComponent<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			loading: false,
			error: none,
		};
	}

	render() {
		return (
			<div className={"c-revolutauth-page"}>
				<img src={logo} className={"c-revolutauth-page_content_logo"}/>
				<h3 className="c-revolutauth-page_content_header">Xero Authorization</h3>
				<div className="c-revolutauth-page_content_form">
					<div className={"c-revolutauth-page_content_form_error"}>
						{this.state.error.map(err => <span>{err}</span>).orNull}
					</div>
					<div className={"c-revolutauth-page_content_form_button"}>
						<ButtonPrimary label={"Go to Xero authorization"}
									   onClick={() => this.onSubmit()}
									   disabled={this.state.loading}
									   isLoading={this.state.loading}/>
					</div>
				</div>
			</div>
		)
	}

	onSubmit(): void {
		this.setState({loading: true}, () => api.instance.xeroAuthApi.fetchAuthorizationPageUrl()
			.then((url) => window.open(url, "_self"))
			.catch(err => {
				this.setState({error: option(err.response.data.message), loading: false});
				notifyBugsnagAndShowToast(err, "Redirect to Xero authorization")
			})
		);
	}
}

export default withRouter(XeroAuthorization);
